// Mobile nav drawer — slide-in panel from the right with a dimmed overlay.
// Opened/closed from the header hamburger (which morphs to an X) and closed
// via the overlay, the Escape key, or selecting a link. Focus is trapped in
// the drawer while open and returned to the hamburger on close.
import $ from 'jquery';

const $hamburger = $('.hamburger[data-toggle="nav-mobile"]');
const $drawer = $('#mobile-nav');
const $overlay = $('.mobile-nav-overlay');
const $root = $('html, body');

// Bail cleanly if the drawer isn't on the page.
if ($drawer.length) {
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  const isOpen = () => $hamburger.attr('aria-expanded') === 'true';

  const focusable = () => $drawer.find(FOCUSABLE).filter(':visible').toArray();

  const onKeydown = (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    // Trap Tab within the drawer.
    const items = focusable();
    if (!items.length) {
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  };

  function open() {
    lastFocused = document.activeElement;

    $root.addClass('nav-mobile-is-visible');
    $hamburger.attr('aria-expanded', 'true').addClass('hamburger--active');
    $drawer.attr('aria-hidden', 'false').scrollTop(0);
    $overlay.attr('aria-hidden', 'false');

    const items = focusable();
    if (items.length) {
      items[0].focus();
    }

    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    $root.removeClass('nav-mobile-is-visible');
    $hamburger.attr('aria-expanded', 'false').removeClass('hamburger--active');
    $drawer.attr('aria-hidden', 'true');
    $overlay.attr('aria-hidden', 'true');

    document.removeEventListener('keydown', onKeydown);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  $hamburger.on('click', (event) => {
    event.preventDefault();
    isOpen() ? close() : open();
  });

  // Close when the dimmed overlay or any menu link is tapped.
  $overlay.on('click', close);
  $drawer.on('click', '.mobile-nav__menu a', close);

  // --------------------------------------------------
  // Accordion — inject a toggle button into every item that has a submenu
  // so nested links can be expanded without leaving the drawer. Decoupled
  // from the menu markup so it works at any depth.
  // --------------------------------------------------
  $drawer.find('.menu-item-has-children').each((_, li) => {
    const $li = $(li);
    const $submenu = $li.children('.sub-menu').first();
    if (!$submenu.length) {
      return;
    }

    const $toggle = $(
      '<button type="button" class="mobile-nav__toggle" aria-expanded="false" aria-label="Toggle submenu">' +
        '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>' +
        '</button>'
    );

    $toggle.on('click', (event) => {
      event.preventDefault();
      const expanded = $toggle.attr('aria-expanded') === 'true';
      $toggle.attr('aria-expanded', String(!expanded));
      $submenu.toggleClass('sub-menu--open', !expanded);
    });

    $li.children('a').first().after($toggle);
  });
}
